module.exports = __webpack_public_path__ + "img/4cfc8999bb24ff45916c19bd95fad9b5.png";